import React, { FC } from 'react';
import { captureEvent } from '../../../../../services/event-capture';
import { Vessel } from '../../../../../services/store/modules/vessels/models';
import WatercraftSelectorSheet from '../../../Vessels/components/WatercraftSelectorSheet';
import RiskForecastEditVesselLengthForm from './RiskForecastEditVesselLengthForm';

export type WatercraftSheetMode = 'manual' | 'select';

interface RiskForecastWatercraftSheetProps {
  mode: WatercraftSheetMode;
  onModeChange: (mode: WatercraftSheetMode) => void;
  vessels: Vessel[];
  vesselLength: number;
  watercraftType?: string;
  onSelectVessel: (vessel: Vessel) => void;
  onAddWatercraft: () => void;
  onManualSave: (newVesselLength: number, watercraftType?: string) => void;
}

const RiskForecastWatercraftSheet: FC<RiskForecastWatercraftSheetProps> = ({
  mode,
  onModeChange,
  vessels,
  vesselLength,
  watercraftType,
  onSelectVessel,
  onAddWatercraft,
  onManualSave,
}) => {
  if (mode === 'select') {
    return (
      <WatercraftSelectorSheet
        vessels={vessels}
        onSelectVessel={onSelectVessel}
        onAddWatercraft={onAddWatercraft}
        onBackToManual={() => {
          captureEvent({
            type: 'Risk forecast: adjust manually click',
            payload: {},
            sendToAmplitude: true,
          });
          onModeChange('manual');
        }}
      />
    );
  }

  return (
    <RiskForecastEditVesselLengthForm
      vesselLength={vesselLength}
      watercraftType={watercraftType}
      saveAction={onManualSave}
    />
  );
};

export default RiskForecastWatercraftSheet;
